import { Injectable } from "@angular/core";
import { SAT_REPORT_ENDPOINTS } from "../../components/mediaManager/reports/sat/sat-report-endpoints";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs";

@Injectable()
export class SatReportService {
    apiEndPoint = SAT_REPORT_ENDPOINTS;

    constructor(protected http: HttpClient) {}

    getCampaigns(filters?: any): Observable<any> {
        return this.http
            .post<any>(this.apiEndPoint.list, filters)
            .pipe(map((response) => response));
    }

    getErrorDetails(campaignId: number, filter: any): Observable<any> {
        return this.http
            .post<any>(
                this.apiEndPoint.error_list.replace(
                    "{id}",
                    campaignId.toString()
                ),
                filter
            )
            .pipe(map((response) => response));
    }
}
